export namespace TeamLibraryConst {
  export enum FileSizeUnit {
    b = 1024,
    kb = 1024,
  }

  export enum MaxFileSizeUnit {
    mb = FileSizeUnit.kb * FileSizeUnit.b
  }

  export enum MaxFileSize {
    Model = 300 * MaxFileSizeUnit.mb // 300 MB
  }

  export enum FileStatus {
    FileValid = 0,
    FileSizeError = 1,
    FileTypeError = 2,
    FileDimensionError = 3,
    FileCountError = 4,
    FileEmptyError = 5,
  }

  export enum MaxFileSizeUnitString {
    mb = 'MB',
  }

  export enum ModelThumbnailDimension {
    width = 320,
    height = 287,
  }

  export enum LibraryCategoriesStateId {
    UnderConstruction = 0,
    Hidden = 5,
    Active = 10,
    Deprecated = 999,
  }

  export const FileStatusMessage: Record<FileStatus, string> = {
    [FileStatus.FileValid]: '',
    [FileStatus.FileSizeError]: `Exceeds ${MaxFileSize.Model / MaxFileSizeUnit.mb}${MaxFileSizeUnitString.mb}`,
    [FileStatus.FileTypeError]: 'Filetype not supported',
    [FileStatus.FileDimensionError]: 'Image dimension not supported',
    [FileStatus.FileCountError]: 'Maximum number of files exceeded',
    [FileStatus.FileEmptyError]: 'File is empty',
  }

  // The /library/v2 listing filter casts category ids against a smallint column,
  // so ids above the PostgreSQL smallint max 500 server-side. Only expose ids the
  // listing API can query safely; entry-editing flows are unaffected.
  export const MaxListingFilterCategoryId: number = 32767

  /**
   * Default library visibility filter. Shared by LibraryFilters (which re-publishes
   * it via its immediate isJigStaffView watch whenever it mounts) and Library.vue
   * (which seeds it before the initial list load) so the two always agree and the
   * mount-time emit dedupes to a no-op instead of a second fetch.
   */
  export const defaultLibraryVisibilityFilter = (isJigSpaceStaff: boolean): { op: string; value: string } =>
    isJigSpaceStaff ? { op: 'any', value: 'public,tenant,private' } : { op: 'eq', value: 'tenant' }

  export const LibraryModalAllowedReferenceType: string[] = ['.pdf']

  export const LibraryEntryMaxReferencePDFs: number = 3

  /** Max file size for reference document uploads (shared by library entry and tenant context). */
  export const ReferenceFileMaxSizeMB: number = 30
  export const ReferenceFileMaxSizeBytes: number = ReferenceFileMaxSizeMB * MaxFileSizeUnit.mb
}
